"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingBox = exports.SpinnerLoader = exports.Loading = void 0;
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importStar(require("styled-components"));
const themes_1 = require("@/theme/themes");
const Loading = ({ style, containerStyle }) => {
    const isDarktheme = (0, react_router_dom_1.useOutletContext)();
    return (react_1.default.createElement(styled_components_1.ThemeProvider, { theme: isDarktheme ? themes_1.darkTheme : themes_1.lightTheme },
        react_1.default.createElement(LoadingGradientContainer, { style: containerStyle },
            react_1.default.createElement(material_1.Box, { style: style },
                react_1.default.createElement(exports.LoadingBox, null)))));
};
exports.Loading = Loading;
const SpinnerLoader = () => {
    return (react_1.default.createElement(material_1.Box, { style: {
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gridColumn: 'span 12',
        } },
        react_1.default.createElement(CustomSpinner, null)));
};
exports.SpinnerLoader = SpinnerLoader;
const CustomSpinner = (0, styled_components_1.default)(material_1.CircularProgress) `
  color: ${(props) => props.theme.colors.onBg} !important;
`;
exports.LoadingBox = (0, styled_components_1.default)(material_1.Box) `
  animation: loading 3s linear;
  animation-iteration-count: infinite;
  background-image: linear-gradient(
    to right,
    rgba(140, 140, 140, 0.05) 0%,
    rgba(140, 140, 140, 0.102) 20%,
    rgba(140, 140, 140, 0.05) 40%
  );
  background-size: 1200px 100%;
  width: 100%;
  border-radius: 20px;
  height: 100%;
`;
const LoadingGradientContainer = (0, styled_components_1.default)('div') `
  background: ${(props) => props.theme.colors.gradientBg};
  column-gap: 15px;
  row-gap: 15px;
  margin-top: ${(props) => props.theme?.spacing?.margin?.xl};
  display: grid;
  grid-column: span 12;
  grid-template-columns: repeat(12, 1fr);
  padding: ${(props) => props.theme?.spacing?.margin?.md};
  border-radius: 30px;
  ${(props) => props.theme.media.lg} {
    margin-top: ${(props) => props.theme.spacing?.margin?.lg};
    grid-column: span 12;
  }
  ${(props) => props.theme.media.md} {
    grid-column: span 12;
    margin-top: ${(props) => props.theme.spacing.margin?.md};
    row-gap: 15px;
  }
  ${(props) => props.theme.media.sm} {
    padding: ${(props) => props.theme.spacing.margin?.sm};
    margin-top: ${(props) => props.theme.spacing.margin?.sm};

    grid-column: span 12;
  }
  ${(props) => props.theme.media.xs} {
    padding: ${(props) => { return props.theme.spacing.margin?.xs; }};
    margin-top: ${(props) => props.theme.spacing.margin?.xs};
    grid-column: span 12;
  }
`;
